/*
 *******************************************************************************
 *
 *  Filename:   @/contexts/shared/reducer.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducer for contexts.
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Saturday, August 19, 2023 - 10:00 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/19  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */
import { INITIALIZE, SIGN_IN, SIGN_OUT, SIGN_UP, SAVE_EMAIL, NEW_PASSWORD } from "./constants";

const reducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE:
      return {
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        authToken: action.payload.authToken ? action.payload.authToken : null,
        user: action.payload.user,
      };
    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        authToken: action.payload.authToken ? action.payload.authToken : null,
        user: action.payload.user,
        newPasswordRequired: false,
      };
    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };

    case SIGN_UP:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };
    case SAVE_EMAIL:
      return {
        ...state,
        email: action.payload ? action.payload.email : "",
      };
    case NEW_PASSWORD:
      return {
        ...state,
        isAuthenticated: false,
        isInitialized: false,
        user: null,
        newPasswordRequired: true,
        session: action.payload.session,
        challengeParameters: action.payload.challengeParameters,
      };
    default:
      return state;
  }
};

export default reducer;
